import { useEffect } from "react";
import { isFieldVisibleForGender } from "../utils/isFieldVisibleForGender";

export const useHiddenFieldsReset = ({ selectedGender, fields, getValues, setValue }) => {
    useEffect(() => {
        if (!selectedGender) return;

        const currentValues = getValues();
        fields.forEach((field) => {
            const isVisible = isFieldVisibleForGender(field, selectedGender);

            if (!isVisible && currentValues[field.name] !== undefined && currentValues[field.name] !== null) {
                setValue(field.name, null, { shouldValidate: false });
            }
        });
    }, [selectedGender, fields, getValues, setValue]);
};
